import { createRoot } from 'react-dom/client'
import './shadcn.css'
import App from './App'

console.log('%c Ultimind App Version: 2026-02-07 Fixed Menu ', 'background: #222; color: #bada55; font-size: 16px; padding: 4px;')

const root = createRoot(document.getElementById('app')!)
root.render(<App />)
